<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios';
import Qs from 'qs';

export default {
    name: 'accommodation',

    components: {
        Multiselect
    },

    props: {
        types: Array,
        price_options: Array,
        drink_types: Array,
        regions: Array,
        diets: Array,
    },

    data: function() {
        return {
            loading: true,
            results: [],
            search: {
                types: [],
                price_options: [],
                drink_types: [],
                regions: [],
                diets: [],
			},
        };
    },


	created() {
        this.fetchTraders();
    },


    watch: {
        search: {
            deep: true,
            handler(new_search, old_search) {
                this.fetchTraders();
            }
        },
    },


    methods: {
        fetchTraders: function() {
            let self = this;

            self.loading = true;

            let params = {
                action: 'get_traders',
                types: self.search.types.map(o => o.value),
                price_options: self.search.price_options.map(o => o.value),
                drink_types: self.search.drink_types.map(o => o.value),
                regions: self.search.regions.map(o => o.value),
                diets: self.search.diets.map(o => o.value),
            };

            axios.post('/wp-admin/admin-ajax.php', Qs.stringify(params))
                .then(function (response) {
                    self.results = response.data.data;
                    self.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },


        isFood: function() {
        	return this.search.types.some(type => type.value === 'food');
		},


        isDrink: function() {
        	return this.search.types.some(type => type.value === 'drink');
		},
    },
};
</script>